<img class="img-hgt" src="/assets/banner3.png" alt="iCBMS">

<div class="container-fluid">
    <ngx-loading [show]="loadingpage"></ngx-loading>
    <div class="row">
        <div class="col-md-4">
            <div class="row">
                <div class="col-md-12">
                    <img class="img-size" src="/assets/3 Vehicles Resized.png" alt="iCBMS">
                </div>
            </div>
        </div>

        <div class="col-md-8">

            <div>
                <div class="card-data">

                    <h1 class="text-center">
                        User Registration
                    </h1>
                    <div class="row">
                        <div class="col-md-12" *ngIf="authWebService.isLoading">
                            <app-busy [message]="message"></app-busy>
                        </div>

                        <div class="col-md-12" style="margin-bottom:5px;margin-top:5px">
                            <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" autocomplete="off">
                                <div class="row">
                                   <div class="form-group col-md-6">
                                        <label>First Name<a class="red-asterik"> *</a></label>
                                        <input type="text" name="FirstName" formControlName="FirstName" (blur)="getErrorFirtsName()" class="form-control input-sm" autocomplete="off" maxlength="50" [ngClass]="{'error':(form.controls['FirstName'].touched && form.controls['FirstName'].invalid)}"
                                        />
                                        <span class="invalid-feedback" *ngIf="form.controls['FirstName'].invalid">
                      {{getErrorFirtsName()}}
                    </span>
                                        <span class="invalid-feedback" *ngIf="form.controls['FirstName'].touched && form.controls['FirstName'].invalid">
                      <span class="invalid-feedback"
                        *ngIf="!form.controls['FirstName'].touched && form.controls['FirstName'].hasError('required')">
                        {{getErrorFirtsName()}}
                      </span>
                                        </span>

                                    </div>


                                    <div class="form-group col-md-6">
                                        <label>Last Name<a class="red-asterik"> *</a></label>
                                        <input type="text" name="LastName" formControlName="LastName" class="form-control input-sm" autocomplete="off" maxlength="50" [ngClass]="{'error':(form.controls['LastName'].touched && form.controls['LastName'].invalid)}" />
                                        <span class="invalid-feedback" *ngIf=" form.controls['LastName'].invalid">
                      {{getErrorLastName()}}
                    </span>
                                        <span class="invalid-feedback" *ngIf="form.controls['LastName'].touched && form.controls['LastName'].invalid">
                      <span class="invalid-feedback"
                        *ngIf="!form.controls['LastName'].touched && form.controls['LastName'].hasError('required')">
                        {{getErrorLastName()}}
                      </span>
                                        </span>

                                    </div>



                                    <div class="form-group col-md-6">
                                        <!-- <label >Mobile Number*</label> -->
                                        <!-- <input type="text"
                    
                     name="MobileNumber"  
                     formControlName="MobileNumber"
                     
                     id="email"
                      class="form-control input-sm"
                    [ngClass]="{'error':(form.controls['MobileNumber'].touched && form.controls['MobileNumber'].invalid)}"/>
                    <span class="invalid-feedback" *ngIf="form.controls['MobileNumber'].touched && form.controls['MobileNumber'].invalid">
                      {{getErrorMobileNumber()}}
                      </span> -->
                                        <div class="mb-2">
                                            <label>Mobile Number<a class="red-asterik"> *</a></label>
                                        </div>
                                        <ngx-intl-tel-input [cssClass]="'form-control input-sm'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                            [selectFirstCountry]="false" [selectedCountryISO]="defaultCountry" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true" [separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
                                            name="MobileNumber" formControlName="MobileNumber">
                                        </ngx-intl-tel-input>
                                        <span class="invalid-feedback" *ngIf="form.controls.MobileNumber.invalid && form.controls.MobileNumber.dirty">
                                            <p *ngIf="form.controls.MobileNumber.errors.required">* Mobile Number is required</p>
                                            <p *ngIf="form.controls.MobileNumber.errors && !form.controls.MobileNumber.errors.required">* Invalid Mobile Number</p>
                                        </span>

                                    </div>
                                    <div class="form-group col-md-6">
                                        <!-- <label>Phone Number</label>
                    <input type="text" name="PhoneNumber"
                     formControlName="PhoneNumber"
                     
                     class="form-control input-sm" 
                    /> -->
                                        <!--  <span class="invalid-feedback" *ngIf="form.controls['PhoneNumber'].touched && form.controls['PhoneNumber'].invalid">
                      {{getErrorPhoneNumber()}}
                      </span> -->
                                        <div class="mb-2">
                                            <label>Phone Number</label>
                                        </div>
                                        <ngx-intl-tel-input [cssClass]="'form-control input-sm'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                            [selectFirstCountry]="false" [selectedCountryISO]="defaultCountryPhone" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true" [separateDialCode]="separateDialCode" (countryChange)="ChangeCountryPhone($event)"
                                            name="PhoneNumber" formControlName="PhoneNumber">
                                        </ngx-intl-tel-input>
                                        <span class="invalid-feedback" *ngIf="form.controls.PhoneNumber.invalid && form.controls.PhoneNumber.dirty">
                                            <p *ngIf="form.controls.PhoneNumber.errors.required">* Phone Number is required</p>
                                            <p *ngIf="form.controls.PhoneNumber.errors && !form.controls.PhoneNumber.errors.required">* Invalid Mobile Number</p>
                                        </span>
                                    </div>

                                    <div class="form-group col-md-6" id="ssoemailusername">
                                        <label>Email<a class="red-asterik"> *</a></label>
                                        <input type="text" name="email" formControlName="UserName" autocomplete="off" class="form-control input-sm" [ngClass]="{'error':(form.controls['UserName'].touched && form.controls['UserName'].invalid)}" #email />
                                        <span class="invalid-feedback" *ngIf="form.controls['UserName'].invalid">
                      {{getErrorEmail()}}
                    </span>
                                        <span class="invalid-feedback" *ngIf="form.controls['EmailAddress'].touched && form.controls['EmailAddress'].invalid">
                      <!-- <span class="invalid-feedback"
                        *ngIf="form.controls['UserName'].hasError('required')">
                        {{getErrorEmail()}}
                      </span> -->
                                        </span>
                                    </div>
                                    <div class="form-group col-md-6" id="sooconfirmemail">
                                        <label>Confirm Email<a class="red-asterik"> *</a></label>
                                        <input type="text" style="background-color:white" name="email" formControlName="EmailAddress" (blur)="emailVerification(email.value,cnfmEmail.value)" class="form-control input-sm" [ngClass]="{'error':(form.controls['EmailAddress'].touched && form.controls['EmailAddress'].invalid)}"
                                            #cnfmEmail autocomplete="off" readonly onclick="this.removeAttribute('readonly');"/>
                                        <span class="invalid-feedback" *ngIf="form.controls['EmailAddress'].invalid">
                      {{getConfirmEmail()}}
                    </span>
                                    </div>


                                    <div class="form-group col-md-6" id="passwordfield">
                                        <label>Password<a class="red-asterik"> *</a></label>
                                        <span class="p-viewer">
                                        <i class="fa fa-eye-slash" *ngIf="hide==false" id="input_img" (click)="showPassword()" aria-hidden="true"></i>
                                         <i class="fa fa-eye" *ngIf="this.form.value.Password && hide==true" (click)="showPassword()" id="input_img" aria-hidden="true"></i>
                                        </span>
                                         <input  [type]="hide ? 'password' : 'text'" name="Password" formControlName="Password" class="form-control input-sm" minlength="8" [ngClass]="{'error':(form.controls['Password'].touched && form.controls['Password'].invalid)}" autocomplete="off" #pwd />
                                        <span class="invalid-feedback" *ngIf="form.controls['Password'].invalid">
                      {{getPasswordErr()}}
                    </span>
                                        <span class="invalid-feedback" *ngIf="form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid">
                      <span
                        *ngIf="!form.controls['Password'].touched && form.controls['Password'].hasError('required')">
                        {{getPasswordErr()}}
                      </span>
                                        </span>
                                    </div>
                                    <div class="form-group col-md-6" id="passwordfieldnew">
                                        <label>Confirm Password<a class="red-asterik"> *</a></label>
                                        <span class="p-viewernew">
                                            <i class="fa fa-eye-slash" *ngIf="hideNew==false" id="input_img" (click)="showPasswordNew()" aria-hidden="true"></i>
                                             <i class="fa fa-eye" *ngIf="this.form.value.ConfirmPassword && hideNew==true" (click)="showPasswordNew()" id="input_img" aria-hidden="true"></i>
                                            </span>
                                        <input [type]="hideNew ? 'password' : 'text'" name="ConfirmPassword" (blur)="passwordMatch(pwd.value,cnfPwd.value)" minlength="8" formControlName="ConfirmPassword" class="form-control input-sm" [ngClass]="{'error':(form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid)}"
                                            #cnfPwd />
                                        <span class="invalid-feedback" *ngIf="form.controls['ConfirmPassword'].invalid">
                      {{getConfirmPasswordErr()}}
                    </span>

                                    </div>
                                    <div class="form-group col-md-6">
                                        Send confirmation link by <a class="red-asterik"> * </a>
                                        <input type="radio" name="corspd-type" value="1" ([ngModel])="correspondenceType" [checked]="correspondenceType=='1'" (click)="selectcorrespondenceType('1')" /> Email
                                        <input type="radio" name="corspd-type" value="2" ([ngModel])="correspondenceType" [checked]="correspondenceType=='2'" (click)="selectcorrespondenceType('2')" /> SMS
                                    
                                        <!-- <span class="invalid-feedback" *ngIf="form.controls['correspondenceType'].invalid">
                                            {{getErrorCorrespondenceType()}}
                                          </span> -->
                                    </div>
                                    

                                    <div class="form-group col-md-6">
                                        <p>Fields marked with <a class="red-asterik"> *</a> are mandatory. Note that your <b>Email Address</b> will be your <b>Username</b>.</p>
                                        <input type="checkbox" name="terms-check" value="1" ([ngModel])="terms" [checked]="terms=='1'" (click)="ckeckTerms($event)" /> By clicking the checkbox, you note our
                                        <a href="#"  data-toggle="modal" data-target="#POPIA" >POPIA Processing Notice</a>

                                    </div>
                                    <div class="form-group col-md-12 mb-1 mt-3">
                                        <div class="row" *ngIf="showCaptcha && environment != 'qa'">
                                            <div class="form-group col-md-4">
                                                <re-captcha style="width: 100% !important;" (resolved)="resolved($event)" siteKey="{{getSiteKey()}}"></re-captcha>

                                            </div>
                                        </div>


                                        <div class="form-group col-md-4 btn-move">
                                           <!-- <button subMenuAction="ADD-USER" class="btn btn-block m-clr" [disabled]="!form.valid && socialLogin == false">Register</button>-->
                                            <!--<button subMenuAction="ADD-USER" class="btn btn-block m-clr">Register</button>-->
                                            <button type="submit"
                                            class="btn btn-primary">Register
                                    </button>
                                        </div>
                                        <br />





                                    </div>
                                    <p class="cancel-par">Already registered? <a class="txt-deco" routerLink="/login">Click Here</a></p>


                                </div>
                            </form>
                            <div class="separator">OR</div>
                            <div class="row">
                                <div class="col-6">
                                    <button (click)="socialSignIn('facebook')" class="btn btn-md m-clr hd-btn loginBtn loginBtn--facebook">
                    <i class="fa fa-facebook mr-1"></i>
                    Login with Facebook
                  </button>

                                </div>
                                <div class="col-6 text-right">

                                    <button class="btn btn-md m-clr hd-btn loginBtn loginBtn--google" #loginRef>
                    <i class="fa fa-google mr-1"></i>
                    Login with Google
                  </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="POPIA" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">POPIA Processing Notice</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">

                <div class="clearfix section  pb-8 text-gray"><div class=""><div class="bg-transparent matrix-copy 1 1 normal "><div class="mb-0-lastchild  "><h3 class="text-blue font-weight-semi-bold">Background to data privacy in South Africa</h3><p><br>The Protection of Personal Information Act, 4 of 2013, (“POPIA”), which came into force on 1 July 2021, is a law which regulates the use and processing of a person and / legal entity’s personal information, this being in response to, and in order to protect and give effect to a person and/or legal entity’s rights to privacy, including the right not to have their / its personal information and related data misused, abused or used for ulterior purposes.</p><p>POPIA applies to personal information which belongs to individuals and legal entities (“Data Subjects”) which is processed, be it in an automated or non-automated manner in South Africa, by another (“Responsible Party”) and places on any Responsible Party who is processing a data Subject’s personal information, a duty to use it lawfully and only for a specific and defined purpose(s).</p><p>In terms of POPIA, Cross Border Road Transport Agency (C-BRTA) , as a Responsible Party, is required to appoint an Information Officer (“IO”) and Deputy Information Officers (“DIOs”), to be responsible for establishing a POPIA Compliance Framework, and who following this, are required to assess, analyse and understand what types of personal information C-BRTA is processing which belongs to Data Subjects and to thereafter develop certain processes and procedures, including a POPIA Policy, which have to be followed by all C-BRTA employees when they process and use another’s personal information.</p><p>A Personal Information Impact Assessment as per the C-BRTA’s POPIA Compliance Framework has been carried out and created, which has indicated that C-BRTA , during the course of its business activities does and will continue to collect, store and process personal information about C-BRTA employees, its customers, suppliers and other third parties.</p><p>Furthermore, the Impact Assessment has defined and revealed that C-BRTA processes a large amount of different types of personal information including names, addresses, opinions, financial details, medical details and the like which pertain to current, past and prospective employees and customers, suppliers, and others who C-BRTA communicates and deals with and which processing is carried out for a variety of purposes, including for business, compliance and legal purposes.</p><p>C-BRTA also processes special purpose information including gender, sex, marital status, colour, age, race or ethnic origin, religious beliefs, trade union membership and the like for the purposes of recruitment, employment equity statistics, legal compliance and for the facilitation of union fees and memberships.</p><p>Following the Personal Information Impact Assessment, C-BRTA is confident that whilst this personal information is held on paper or on a computer or other media, such storage is subject to the prescribed legal safeguards as specified in POPIA and other regulations.</p><p>As per the POPIA requirements has implemented a robust POPIA compliance programme which includes various POPIA policies and processes, some of which are internal documents and some are which are available for public access. These documents are available for public access and can be accessed in the menu on the left.<br></p><p><br></p></div></div></div></div>

                

               

            </div>
            <div class="modal-footer">
              
                <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"  data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>

   
</div>
